





































































import { defineComponent, reactive, toRefs, PropType, computed, watch, onMounted } from '@vue/composition-api';
import * as Common from "../commons/common"
import http from "../plugins/http";
import AlertArea from "../components/AlertArea.vue";
import { Examinee, ReviewText } from "../modules/teacher/SaitenList"
// @ts-ignore
import { longClickDirective } from 'vue-long-click'
const longClickInstance = longClickDirective({delay: 500, interval: 0})
// @ts-ignore
import VueDragResize from "vue-drag-resize";
import { SheetActivity } from '../modules/teacher/SaitenList';

export interface Data {
  inputScale: number
  pageIdx: number
  headerHeight: number
  footerHeight: number
  startPos: Common.Point
  scrollPos: Common.Point
  isDragging: boolean
  isScrolling: boolean
  fontSize: number
  lineHeight: number
  currentReviewText: ReviewText
  errors: string[]
}

export default defineComponent({
  directives: {
    longclick: longClickInstance
  },
  components: {
    "vue-drag-resize": VueDragResize,
    "alert-area": AlertArea,
  },
  props: {
    examinee: {
      type: Examinee as PropType<Examinee>,
      required: true
    },
    modalHeight: {
      type: Number as PropType<number>,
      required: true
    },
    imageWidth: {
      type: Number as PropType<number>,
      required: true
    },
    imageHeight: {
      type: Number as PropType<number>,
      required: true
    },
  },
  setup (props, context) {

    /************************************************************
     * Data
     ************************************************************/

    const state = reactive<Data>({
      inputScale: 50,
      pageIdx: 0,
      headerHeight: 46,
      footerHeight: 35,
      startPos: new Common.Point(0, 0),
      scrollPos: new Common.Point(0, 0),
      isDragging: false,
      isScrolling: false,
      fontSize: 48,
      lineHeight: 0,
      currentReviewText: null,
      errors: [],
    });

    /************************************************************
     * 表示対象のsheet_activity
     ************************************************************/

    const currentSheetActivity = computed((): SheetActivity => {
      return props.examinee.sheetActivities[state.pageIdx];
    });

    /************************************************************
     * 表示対象のbase64ResultImage
     ************************************************************/

    const currentBase64ResultImage = computed((): string => {
      return props.examinee.base64ResultImages[state.pageIdx];
    });

    /************************************************************
     * 画像領域の高さ
     ************************************************************/

    const imageAreaHeight = computed((): number => {
      return props.modalHeight - state.headerHeight - state.footerHeight;
    });

    /************************************************************
     * スライダーの倍率を画像倍率に変換
     ************************************************************/

    const scale = computed((): number => {
      return Number(state.inputScale / 100);
    });

    /************************************************************
     * 画像の親DivのCSSスタイル
     ************************************************************/

    const imageStyle = computed((): any => {
      const style: any = {};
      style["width"] = `${props.imageWidth * scale.value}px`;
      style["height"] = `${props.imageHeight * scale.value}px`;
      return style;
    });

    /************************************************************
     * 表示対象生徒切り替え
     ************************************************************/

    const changeExaminee = async (addCount: number) => {
      state.currentReviewText = null;
      props.examinee.sheetActivities.forEach(SheetActivity => {
        SheetActivity.reviewTexts.forEach(reviewText => {
          reviewText.is_active = false;
        });
      });
      context.emit("change-review-examinee", props.examinee, addCount);
    }

    /************************************************************
     * ページ切り替え
     ************************************************************/

    const changePage = (idx: number) => {
      state.currentReviewText = null;
      props.examinee.sheetActivities.forEach(SheetActivity => {
        SheetActivity.reviewTexts.forEach(reviewText => {
          reviewText.is_active = false;
        });
      });
      state.pageIdx = idx;
    }

    /************************************************************
     * マウス座標取得
     ************************************************************/

    const getMousePos = (e: MouseEvent) => {
      const x: number = e.offsetX / scale.value;
      const y: number = e.offsetY / scale.value;
      return new Common.Point(x, y);
    };

    /************************************************************
     * Touchイベントの座標取得
     ************************************************************/

    const getTouchPos = (t: Touch, canvas: HTMLElement) => {
      const x: number = (t.clientX - canvas.getBoundingClientRect().left) / scale.value;
      const y: number = (t.clientY - canvas.getBoundingClientRect().top) / scale.value;
      return new Common.Point(x, y);
    }

    /************************************************************
     * 答案mousedown
     ************************************************************/

    const fieldMouseDown = (e: MouseEvent) => {
      const field = document.getElementById("image-parent");
      state.startPos =  getMousePos(e);
      state.scrollPos = new Common.Point(field.scrollLeft, field.scrollTop);
      state.isDragging = false;
      state.isScrolling = false;
      state.currentReviewText = null;
    }

    /************************************************************
     * 答案mousemove
     ************************************************************/

    const fieldMouseMove = (e: MouseEvent) => {
      const field = document.getElementById("image-parent");
      const endPos = getMousePos(e);
      const scrollEndPos = new Common.Point(field.scrollLeft, field.scrollTop);
      const limit = 5;
        if(endPos.x - state.startPos.x > limit || endPos.x - state.startPos.x < -limit || endPos.y - state.startPos.y > limit || endPos.y - state.startPos.y < -limit
          || scrollEndPos.x - state.scrollPos.x >  limit || scrollEndPos.x - state.scrollPos.x < -limit || scrollEndPos.y - state.scrollPos.y >  limit || scrollEndPos.y - state.scrollPos.y < -limit){
          state.isScrolling = true;
        }
    }

    /************************************************************
     * 答案mouseup
     ************************************************************/

    const fieldMouseUp = () => {
      state.isScrolling = false;
    }

    /************************************************************
     * 答案mouseleave
     ************************************************************/

    const fieldMouseLeave = () => {
      state.isScrolling = false;
    }

    /************************************************************
     * 答案touchstart
     ************************************************************/

    const fieldTouchStart = (e: TouchEvent) => {
      const field = document.getElementById("image-parent");
      state.startPos =  getTouchPos(e.changedTouches[0], field);
      state.scrollPos = new Common.Point(field.scrollLeft, field.scrollTop);
      state.isDragging = false;
      state.currentReviewText = null;
    }

    /************************************************************
     * 答案touchmove
     ************************************************************/

    const fieldTouchMove = (e: TouchEvent) => {
      const field = document.getElementById("image-parent");
      const endPos = getTouchPos((e as TouchEvent).changedTouches[0], field);
      const scrollEndPos = new Common.Point(field.scrollLeft, field.scrollTop);
      const limit = 10;
      if(endPos.x - state.startPos.x > limit || endPos.x - state.startPos.x < -limit || endPos.y - state.startPos.y > limit || endPos.y - state.startPos.y < -limit
        || scrollEndPos.x - state.scrollPos.x >  limit || scrollEndPos.x - state.scrollPos.x < -limit || scrollEndPos.y - state.scrollPos.y >  limit || scrollEndPos.y - state.scrollPos.y < -limit){
        state.isScrolling = true;
      }else{
        state.isScrolling = false;
      }
    }

    /************************************************************
     * 答案touchend
     ************************************************************/

    const fieldTouchEnd = () => {
      state.isScrolling = false;
    }

    /************************************************************
     * 答案長押し
     ************************************************************/

    const fieldLongClicked = () => {   

      // スクロール中の場合はリターン
      if(state.isScrolling){
        return;
      }

      // 講評コメントスタンプ出力
      const reviewText = new ReviewText();
      const size = Common.getTextSize("", state.fontSize, state.lineHeight);
      reviewText.sheet_activity_id = currentSheetActivity.value.id;
      reviewText.idx = currentSheetActivity.value.idx++;
      reviewText.font_size = state.fontSize;
      reviewText.line_height = state.lineHeight;
      reviewText.color = "red";
      reviewText.x = state.startPos.x;
      reviewText.y = state.startPos.y;
      reviewText.width = size.width;
      reviewText.height = size.height;
      reviewText.is_active = true;
      reviewText.base64_text = Common.createBase64Text(reviewText);
      currentSheetActivity.value.reviewTexts.push(reviewText);
      state.currentReviewText = reviewText;
    }

    /************************************************************
     * テキストmousedown
     ************************************************************/

    const textMouseDown = (reviewText: ReviewText) => {
      state.startPos = new Common.Point(reviewText.x, reviewText.y);
    }

    /************************************************************
     * テキストmouseup
     ************************************************************/

    const textMouseUp = (reviewText: ReviewText) => {
      for(let reviewText of currentSheetActivity.value.reviewTexts){
        reviewText.is_active = false;
      }
      reviewText.is_active = true;
      state.currentReviewText = reviewText;
      state.fontSize = state.currentReviewText.font_size;
      state.lineHeight = state.currentReviewText.line_height;
    }

    /************************************************************
     * テキスト画像のアクティブ判定
     ************************************************************/

    const isSelected = (reviewText: ReviewText) => {
      return state.currentReviewText == reviewText;
    };

    /************************************************************
     * テキスト画像ドラッグ中
     ************************************************************/

    const textDragging = (reviewText: ReviewText, rect: any) => {
      reviewText.x = rect.left / scale.value;
      reviewText.y = rect.top / scale.value;
      state.isDragging = true;
    }

    /************************************************************
     * テキスト画像ドラッグ終了
     ************************************************************/

    const textDragStop = (reviewText: ReviewText, rect: any) => {
      state.isDragging = false;
      if(rect.left < 0){
        reviewText.x = reviewText.x == 1 ? 0 : 1;
      }else if(rect.left + rect.width > props.imageWidth * scale.value){
        const limitX = (props.imageWidth * scale.value - rect.width) / scale.value;
        reviewText.x = reviewText.x == limitX ? limitX - 1 : limitX;
      }else{
        reviewText.x = rect.left / scale.value;
      }

      if(rect.top < 0){
        reviewText.y = reviewText.y == 1 ? 0 : 1;
      }else if(rect.top + rect.height > props.imageHeight * scale.value){
        const limitY = (props.imageHeight * scale.value - rect.height) / scale.value
        reviewText.y = reviewText.y == limitY ? limitY - 1 : limitY;
      }else{
        reviewText.y = rect.top / scale.value;
      }
    }

    /************************************************************
     * テキスト長押し削除
     ************************************************************/

    const textLongClicked = (reviewText: ReviewText) => {
      const limit = 10;
      const moveX = reviewText.x - state.startPos.x;
      const moveY = reviewText.y - state.startPos.y;
      if(moveX < limit && moveX > -limit && moveY < limit && moveY > -limit){
        const idx = currentSheetActivity.value.reviewTexts.indexOf(reviewText);
        currentSheetActivity.value.reviewTexts.splice(idx, 1);
        state.currentReviewText = null;
      }
    }

    /************************************************************
     * 出力済みテキストスタンプ文言編集後イベント
     ************************************************************/

    const changeReviewText = () => {
      const size = Common.getTextSize(state.currentReviewText.text, state.fontSize, state.lineHeight);
      state.currentReviewText.width = size.width;
      state.currentReviewText.height = size.height;
      state.currentReviewText.base64_text = Common.createBase64Text(state.currentReviewText);
    }

    /************************************************************
     * 出力済みテキストスタンプのフォントサイズ・行間変更後イベント
     ************************************************************/

    const textFormatChanged = () => {
      state.currentReviewText.font_size = state.fontSize;
      state.currentReviewText.line_height = state.lineHeight;
      const size = Common.getTextSize(state.currentReviewText.text, state.fontSize, state.lineHeight);
      state.currentReviewText.width = size.width;
      state.currentReviewText.height = size.height;
      state.currentReviewText.base64_text = Common.createBase64Text(state.currentReviewText);
    }

    /************************************************************
     * 更新
     ************************************************************/

    const update = async () => {

      let reviewTexts: ReviewText[] = []
      props.examinee.sheetActivities.forEach(x => {
        reviewTexts = reviewTexts.concat(x.reviewTexts);
      });

      if(reviewTexts.filter(x => x.text == null || x.text == "").length > 0){
        alert("何も入力していない講評テキストが出力されているため更新できません。\r\n未入力の講評テキストを削除するか、テキストを入力してください。");
        return;
      }

      if(!window.confirm(`${props.examinee.student_name}さんの講評コメントを更新します。よろしいですか？`)){
        return;
      }

      const param = {
        review_texts: reviewTexts.filter(x => x.text != null && x.text.replace(/\r?\n/g, '').trim() != "" && x.width > 0 &&  x.height > 0),
        sheet_id: props.examinee.sheet_id,
        examinee_id: props.examinee.id
      }

      context.emit("update-review", param);
   }

    /************************************************************
     * mounted
     ************************************************************/
    
    onMounted(async () => {
      const imageWrap = document.getElementById("image-wrap");
      const imageWrapWidth = imageWrap.clientWidth - 20;
      const imageWrapHeight = imageWrap.clientHeight - 20;
      const perW = imageWrapWidth / props.imageWidth;
      const perH = imageWrapHeight / props.imageHeight;
      state.inputScale = perW > perH ? perH * 100 : perW * 100;
    });

    return {
      ...toRefs(state),
      scale,
      currentSheetActivity,
      currentBase64ResultImage,
      imageAreaHeight,
      imageStyle,
      changeExaminee,
      fieldMouseDown,
      fieldMouseMove,
      fieldMouseUp,
      fieldMouseLeave,
      fieldTouchStart,
      fieldTouchMove,
      fieldTouchEnd,
      fieldLongClicked,
      isSelected,
      textDragging,
      textDragStop,
      textLongClicked,
      textMouseDown,
      textMouseUp,
      changeReviewText,
      textFormatChanged,
      update,
      changePage,
    }
  }
});
